module.exports = __webpack_public_path__ + "static/media/Avatars_Male-16.9a5c3561.png";